import "../Styles/CarDelivery.css";
import { useState, useRef, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { carModels, otp } from "../api";
import { BeatLoader } from "react-spinners";
import AddressCard from "../Components/AddressCard";
import { Link } from "react-router-dom";
import AddAddress from "./AddAddress";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { GoPlusSmall } from "react-icons/go";
import AddressList from "./AddressList";
import car from "../Images/cardelivery.svg";
import * as yup from "yup";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { countries, carBranches } from "../api";
import CountriesModal from "../Components/CountriesModal";
import useGeoLocation from "../Components/useGeoLocation";
import PickerModal from "../Components/PickerModal";

function CarDelivery() {
  const [page1, setPage1] = useState(true);
  const { t, i18n } = useTranslation();
  const [country, setCountry] = useState([]);
  const location = useGeoLocation();
  const [countryModal, setCountryModal] = useState(false);

  const [carColors, setcarColors] = useState(null);
  const [carBrands, setcarBrands] = useState(null);

  const [showColorModal, setShowColorModal] = useState(false);
  const [showBrandModal, setShowBrandModal] = useState(false);
  const [showModelModal, setShowModelModal] = useState(false);

  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);

  const history = useNavigate();
  const [loading, setLoading] = useState(false);

  const Schema = yup.object().shape({
    color: yup.string().required("validation.color_required"),
    model: yup.string().required("validation.model_required"),
    number: yup.string().required("validation.number_required"),
  });

  const formik = useFormik({
    initialValues: {
      color: "",
      model: "",
      number: "",
    },
    validationSchema: Schema,
    onSubmit,
  });

  const colorRef = useRef();
  const modelRef = useRef();
  const notesRef = useRef();
  const numberRef = useRef();

  function onSubmit() {

    console.log("Full:", modelRef.current.value);
    console.log("Brand:", selectedBrand?.id);
    console.log("Name:", selectedModel?.label);

    localStorage.setItem("carColor", colorRef.current.value);
    localStorage.setItem("carmodel", selectedBrand?.id);
    localStorage.setItem("carname", selectedModel?.label);
    localStorage.setItem("carNumber", numberRef.current.value);
    localStorage.setItem("carNotes", notesRef.current.value);
    localStorage.setItem("typeId", 4);

    if (location.loaded && location.coordinates) {
      carBranches(location.coordinates.lat, location.coordinates.lng).then(
        (response) => {
          localStorage.setItem(
            "nearBranches",
            JSON.stringify(response.data.data)
          );
          localStorage.setItem("addressLat", location.coordinates.lat);
          localStorage.setItem("addressLong", location.coordinates.lng);

          history("/branch");
        }
      );
    } else {
      localStorage.setItem("nearBranches", JSON.stringify([]));
      history("/branch");
    }
  }

  useEffect(() => {
    setLoading(true);

    carModels().then((res) => {
      const data = res.data.data;

      // Colors
      const colorOptions = data.colors.map((c) => ({
        id: c.hex,
        label: i18n.language === "ar" ? c.name.ar : c.name.en,
        color: c.hex,
      }));

      // Brands (with nested models)
      console.log(data.models)
      const brandOptions = data.models.map((b, idx) => ({
        id: i18n.language == "ar" ? b.brand.ar : b.brand.en,
        label: i18n.language == "ar" ? b.brand.ar : b.brand.en,
        iconUrl: b.logo || b.iconUrl,
        models: b.models,
      }));

      setcarColors(colorOptions);
      setcarBrands(brandOptions);
      setLoading(false);
    });

    window.scrollTo(0, 0);
  }, [i18n.language]);

  if (loading) {
    return (
      <div className="loader">
        <BeatLoader color={"#E47100"} loading={loading} size={30} />
      </div>
    );
  }

  return (
    <div>
      {countryModal ? (
        <CountriesModal country={country} setModal={setCountryModal} />
      ) : null}

      <div className="Address container-fluid fluid">
        <div className="addressNav ">
          <p>
            <Link to="/">{t("address.home")}</Link>
            {i18n.language === "ar" ? (
              <IoIosArrowBack style={{ color: "#4F4F4F" }} />
            ) : (
              <IoIosArrowForward style={{ color: "#4F4F4F" }} />
            )}
            <span> {t("home.option-car")}</span>
          </p>
        </div>

        <div>
          <div className="addressBody">
            <div className="row addressInput vAlign">
              <div className="col-md-6 ">
                <form onSubmit={formik.handleSubmit}>
                  <div style={{ textAlign: "center" }}>
                    <p className="carTitle">{t("car.carDetails")}</p>
                  </div>

                  <div className="row gy-4">
                    {/* Car Color */}
                    <div className="col-12">
                      <label>{t("car.carColorEnter")}</label>
                      <input
                        placeholder={t("car.carColor")}
                        value={formik.values.color}
                        id="color"
                        name="color"
                        ref={colorRef}
                        readOnly
                        onClick={() => setShowColorModal(true)}
                        required
                        onBlur={formik.handleBlur}
                        className={
                          formik.errors.color && formik.touched.color
                            ? "invalid"
                            : null
                        }
                      />
                      <span>
                        {formik.errors.color && formik.touched.color
                          ? t(`${formik.errors.color}`)
                          : null}
                      </span>
                    </div>

                    {/* Car Model (Brand + Model) */}
                    <div className="col-12">
                      <label>{t("car.carModelEnter")}</label>
                      <input
                        placeholder={t("car.carModel")}
                        value={formik.values.model}
                        id="model"
                        name="model"
                        ref={modelRef}
                        readOnly
                        onClick={() => setShowBrandModal(true)}
                        required
                        onBlur={formik.handleBlur}
                        className={
                          formik.errors.model && formik.touched.model
                            ? "invalid"
                            : null
                        }
                      />
                      <span>
                        {formik.errors.model && formik.touched.model
                          ? t(`${formik.errors.model}`)
                          : null}
                      </span>
                    </div>

                    {/* Car Number */}
                    <div className="col-12">
                      <label>{t("car.carNumberEnter")}</label>
                      <input
                        placeholder={t("car.carNumber")}
                        value={formik.values.number}
                        id="number"
                        name="number"
                        ref={numberRef}
                        required
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={
                          formik.errors.number && formik.touched.number
                            ? "invalid"
                            : null
                        }
                      />
                      <span>
                        {formik.errors.number && formik.touched.number
                          ? t(`${formik.errors.number}`)
                          : null}
                      </span>
                    </div>

                    {/* Notes */}
                    <div className="col-12">
                      <label>{t("basket.enter_your_notes")}</label>
                      <textarea
                        placeholder={t("basket.notes")}
                        id="notes"
                        name="notes"
                        ref={notesRef}
                      />
                    </div>

                    <div className="col-12">
                      <button type="submit">{t("car.confirm")}</button>
                    </div>
                  </div>
                </form>
              </div>

              <div className="col-md-6 vAlign order-first order-md-last">
                <img src={car} alt="car delivery" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== MODALS ===== */}
      {/* Car Color Picker */}
      <PickerModal
        show={showColorModal}
        onHide={() => setShowColorModal(false)}
        title={t("choose_color")}
        options={carColors || []}
        selected={selectedColor?.label}
        onSelect={(opt) => {
          setSelectedColor(opt);
          formik.setFieldValue("color", opt.label);
          setShowColorModal(false)
        }}
      />

      {/* Car Brand Picker */}
      <PickerModal
        show={showBrandModal}
        onHide={() => setShowBrandModal(false)}
        title={t("choose_brand")}
        options={carBrands || []}
        selected={selectedBrand?.id}
        onSelect={(opt) => {
          setSelectedBrand(opt);

          setShowBrandModal(false);
          setShowModelModal(true);
        }}
      />

      {/* Car Model Picker */}
      <PickerModal
        show={showModelModal}
        onHide={() => setShowModelModal(false)}
        title={t("choose_car")}
        options={
          selectedBrand
            ? selectedBrand.models.map((m, idx) => ({ id: idx, label: m }))
            : []
        }
        selected={selectedModel?.label}
        onSelect={(opt) => {
          setSelectedModel(opt);
          formik.setFieldValue("model", `${selectedBrand.id} ${opt.label}`);
          setShowModelModal(false);
        }}
      />






      <Footer />
    </div>
  );
}

export default CarDelivery;
